import React from "react";
import InstantTranscription from "../../Asset/Instant Transcription.svg";
import RealTimeTranslation from "../../Asset/Real-Time Translation.svg";
import SmartEnhancement from "../../Asset/sparkles.svg";
import { ReactSVG } from "react-svg";
import { useInView } from "react-intersection-observer";

const Feature = () => {
  const features = [
    {
      icon: InstantTranscription,
      title: "Instant Transcription",
      summary:
        "Speak naturally and watch your words turn into structured, accurate text, instantly. ZeroTyping eliminates manual typing for blogs, emails, notes, and more.",
    },
    {
      icon: RealTimeTranslation,
      title: "Real-Time Translation",
      summary:
        "Speak in your native language and get instant, fluent translations in 99+ languages, perfect for meetings, messages, and global communication.",
    },
    {
      icon: SmartEnhancement,
      title: "Smart Enhancement",
      summary:
        "Auto-correct grammar, adjust tone, and translate across 40+ languages, all in real time. Let AI refine your message while you focus on your ideas.",
    },
  ];

  const { ref: featuresRef, inView: featuresView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  return (
    <div className=" relative bg-white z-[5] flex md:flex-row flex-col items-stretch justify-evenly xl:gap-10 gap-6 md:mx-[5%] mx-[3%]">
      {features?.map((feature, i) => (
        <div
          ref={featuresRef}
          key={i}
          className={`${
            featuresView ? `animate-scaleIn anim-preserve` : "opacity-0"
          } flex flex-col xl:gap-5 lg:gap-4 gap-3`}
        >
          <div className="bg-gradient-to-r from-[#5ECCFF] to-[#407BFF] text-white w-max xl:p-3 p-2 rounded-xl">
            <ReactSVG
              src={feature.icon}
              beforeInjection={(svg) => {
                svg.setAttribute("class", "xl:w-7 w-6 xl:h-7 h-6");
              }}
              className="xl:w-7 w-6"
            />
          </div>
          <h1 className=" xl:text-[1.875rem] lg:text-[1.5rem] text-xl  font-bold font-jakarta text-black">
            {feature.title}
          </h1>
          <div className=" border-[.51px] border-[black]" />
          <p className=" font-inter text-[#00000099] lg:text-base text-sm">
            {feature.summary}
          </p>
        </div>
      ))}
    </div>
  );
};

export default Feature;
